import actionTypes from '../actionTypes';

export const initialState = {
	tableRows: [],
	tableColumns: [],
	/* Loading and error state for the whole page */
	loading: true,
	error: false,
};

const storeDrillDownReducer = (state = initialState, action = {}) => {
	switch (action?.type) {
		/* Initial Loading of the store drill down page */
		case actionTypes.GET_STORE_DRILL_DOWN_DATA: {
			return {
				...state,
				loading: true,
				error: false,
				tableRows: [],
			};
		}

		/* When the loading of the store drill down page is success  */
		case actionTypes.GET_STORE_DRILL_DOWN_DATA_SUCCESS: {
			return {
				...state,
				tableRows: [...action.payload],
				loading: false,
			};
		}

		/* When is there is error during initial loading of the store drill down page */
		case actionTypes.GET_STORE_DRILL_DOWN_DATA_FAILURE: {
			return {
				...state,
				loading: false,
				error: true,
			};
		}

		default:
			return state;
	}
};

export default storeDrillDownReducer;
